export default __webpack_public_path__ + "static/media/jogini waterfall1.919e1afb.jpg";